import {
  ASSIGN_VENDOR_REMARKS_LIST,
  ASSIGN_VENDOR_REMARKS_LIST_SUCCESS,
  ASSIGN_VENDOR_REMARKS_LIST_ERROR,
  ASSIGN_VENDOR_REMARKS_LIST_EMPTY,
} from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const AssignVendorRemarksList = (state = initialState, action) => {
  switch (action.type) {
    case ASSIGN_VENDOR_REMARKS_LIST:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case ASSIGN_VENDOR_REMARKS_LIST_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case ASSIGN_VENDOR_REMARKS_LIST_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case ASSIGN_VENDOR_REMARKS_LIST_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default AssignVendorRemarksList;
